import { render, staticRenderFns } from "./perfiles.vue?vue&type=template&id=58c815b8"
import script from "./perfiles.vue?vue&type=script&lang=js"
export * from "./perfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports